import { mutations } from 'entities';

import { Box, Column } from 'components/Blocks';
import { getFormConfig } from 'components/Form';
import { LockIcon } from 'components/Blocks/Icons';

import { navigateToLogin } from 'providers/Auth';

import { v } from 'utils/validation';
import { useLang } from 'locale';
import { PasswordInput } from './PasswordInput';

const tokenStep = getFormConfig({
  token: v.string(),
  password: v.string().min(3),
  confirmPassword: v.string().min(3),
}).refine((schema) =>
  schema.refine((data) => data.password === data.confirmPassword, {
    message: 'pw-no-match',
    path: ['confirmPassword'],
  }),
);

export function TokenStep({ token }: { token: string }) {
  const { t } = useLang();

  const finish = mutations.auth.resetPasswordByToken.use({
    onSuccess: ({ email }) => {
      navigateToLogin({ emailPasswordReset: email });
    },
  });

  return (
    <tokenStep.Form onSubmit={finish.execute} defaultValues={{ token }}>
      <Box className="mx-auto bg-primary/20 p-2 text-primary" border="circle">
        <LockIcon size={18} />
      </Box>

      <h1 className="text-2xl text-foreground-title phone:text-xl">{t('set-new-password')}</h1>

      <Column gap="6">
        <PasswordInput form={tokenStep} name="password" />

        <PasswordInput form={tokenStep} name="confirmPassword" />

        <tokenStep.SubmitButton className="mt-2 h-auto py-2">
          {t('change-password')}
        </tokenStep.SubmitButton>
      </Column>
    </tokenStep.Form>
  );
}
